import { compose, withState, withHandlers, lifecycle, branch } from "recompose";
import { connect } from "react-redux";
import { stringify } from "query-string";
import { withRouter } from "react-router-dom";
import { createStructuredSelector } from "reselect";
import * as paths from "routes/paths";
import * as hoc from "modules/user/auth/hoc";
import * as insidersApi from "modules/insiders/api";
import * as insidersSelectors from "modules/insiders/selectors";
import { fetchApi } from "core/api/hoc";
import View from "./View";
import { replaceParams } from "core/utils";

export default compose(
  withRouter,
  hoc.withUserData,
  connect(
    createStructuredSelector({
      insider: insidersSelectors.fetchInsider
    })
  ),
  withState("subObjectives", "setSubObjectives", []),
  withState("mainObjective", "setMainObjective", null),
  withState("additionalNotes", "setAdditionalNotes", ""),
  withHandlers({
    onSubObjectiveChange: props => (id, checked) => {
      if (checked) {
        return props.setSubObjectives([...props.subObjectives, id]);
      }
      props.setSubObjectives(props.subObjectives.filter(item => item !== id));
    },
    onMainObjectiveChange: props => id => {
      props.setMainObjective(id);
    },
    onChooseTime: props => () => {
      if (!props.mainObjective || !props.subObjectives.length) return;

      props.history.replace(
        `${replaceParams(paths.candidate.chooseTime, {
          id: props.consultation ? "consultation" : props.match.params.id
        })}?${stringify({
          selection: JSON.stringify({
            main: props.mainObjective,
            sub: props.subObjectives,
            notes: props.additionalNotes
          })
        })}`
      );
    }
  }),
  lifecycle({
    componentWillReceiveProps(nextProps) {
      if (nextProps.mainObjective !== this.props.mainObjective) {
        this.props.setSubObjectives([]);
      }
    }
  }),
  branch(
    props => !props.consultation,
    fetchApi(insidersApi.getInsider, ({ match }) => ({
      payload: {
        id: match.params.id
      },
      selector: insidersSelectors.getInsiderApi,
      sync: true
    }))
  )
)(View);



// WEBPACK FOOTER //
// ./src/components/common/candidate/ScheduleCall/Provider.js